module.exports = __webpack_public_path__ + "assets_1773798366357/img/pic_4.427fca0b.png";